import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import API_SETTINGS from '../../../api/apiSettings';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import LoadingLoader from '../../../components/LoadingLoader/LoadingLoader';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_SESSION_UPDATE, SETTING_SESSION_VIEW } from '../../../constants/menuPermissionConstant';

class OnlineUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            customerService: [],
            onlyOnlineCustomerService: false,
            selectedCustomerService: {},
            showSuccessAlert: false,
            showConfirmAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getUserCustomerService = () => {
        API_SETTINGS.getListCustomerService(this.state.onlyOnlineCustomerService, this.props.token)
            .then(res => {
                this.setState({
                    loading: false,
                    customerService: getContent(res)
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    loading: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    putDataEndSession = () => {
        const data = {
            updated_at: this.state.selectedCustomerService.updated_at
        }

        API_SETTINGS.putDataEndSession(data, this.state.selectedCustomerService.user_nexcare_id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlert: false
                })
                setTimeout(() => {
                    this.setState({ showSuccessAlert: false })
                    this.getUserCustomerService()
                }, 1500);
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleCheckboxOnline = () => {
        this.setState({
            onlyOnlineCustomerService: !this.state.onlyOnlineCustomerService
        }, () => {
            this.getUserCustomerService()
        })
    }

    handleSelectCustomerService = cs => {
        this.setState({
            selectedCustomerService: cs,
            showConfirmAlert: true
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getUserCustomerService();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_SESSION_VIEW]} userPermission={this.props.userDetail.permissions}>
                <LoadingLoader show={this.state.loading} />
                <div className="h-full pb-5">
                    <div className="h-breadcrumb flex justify-between">
                        <BreadCrumbs
                            parentMenu="Pengaturan"
                            serviceMenu="Pengguna Online"
                            title="Pengguna Online"
                        />
                        <div className="flex items-end mr-8">
                            <div className="text-right flex items-center">
                                <input type="checkbox" className="w-5 h-5" id="onlyOnlineCustomerService" value={this.state.onlyOnlineCustomerService} onChange={() => this.handleCheckboxOnline()} />
                                <label htmlFor="onlyOnlineCustomerService" className="select-none text-lg font-medium ml-2">Tampilkan Hanya Pengguna Online</label>
                            </div>
                        </div>
                    </div>

                    {/* CONTENT */}
                    <div className="space-y-3 h-content overflow-auto p-1">
                        {
                            this.state.loading
                                ? <div className="text-xl text-gray-700 font-bold absolute top-1/2 left-1/2">
                                    Sedang memuat...
                                </div>
                                : <>
                                    {
                                        this.state.customerService.length > 0
                                            ? this.state.customerService.map(data =>
                                                <div className="bg-white rounded shadow-box-button" key={data.id}>
                                                    <div className="p-5 flex items-center justify-between">
                                                        <div className="flex items-center">
                                                            <span className="text-xl text-gray-700 font-medium mr-5">{data.name}</span>
                                                            <span className="text-gray-500 mr-5">{moment.utc(data.last_offline).format('DD MMMM YYYY')}</span>
                                                            <span className="text-gray-500 mr-5">{moment.utc(data.last_offline).format('HH:mm')}</span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <div className={data.is_online ? "bg-lightgreen rounded-full h-5 w-5 mr-2" : "bg-lightred rounded-full h-5 w-5 mr-2"}></div>
                                                            <span className="text-xl text-gray-700 font-medium">{data.is_online ? "Online" : "Offline"}</span>
                                                            <CheckPermissionComponent permissionConstant={[SETTING_SESSION_UPDATE]} userPermission={this.props.userDetail.permissions}><button
                                                                type="button"
                                                                id="btnendsession"
                                                                className={data.is_online ? "bg-olddarkblue text-white rounded-lg py-2 px-3 ml-10" : "bg-gray-500 text-white rounded-lg cursor-not-allowed py-2 px-3 ml-10"}
                                                                disabled={!data.is_online}
                                                                onClick={() => this.handleSelectCustomerService(data)}
                                                            >
                                                                End Session
                                                            </button>
                                                            </CheckPermissionComponent>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            : <div className="text-xl text-gray-700 font-bold absolute top-1/2 left-1/2">
                                                Tidak ada Pengguna Online
                                            </div>
                                    }
                                </>
                        }
                    </div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data user cs ini berhasil diupdate!" />
                <Alert show={this.state.showConfirmAlert} icon="warning" button={true} title="Apakah Anda yakin mengupdate user cs ini?" close={() => this.setState({ showConfirmAlert: false })} submit={() => this.putDataEndSession()} />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OnlineUsers);